module.exports = __webpack_public_path__ + "static/how-to-use-4-524abec5dc9cb96a87129937eb5ec16e.png";